import React from 'react';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';

import View from './view';
import schema from './schema';
import { useApiRequest } from '../../../../../utils/hooks';
import { api as endpoints } from '../../../../../utils/api';

const Component = () => {
  const { state, resetState, execute } = useApiRequest();
  const form = useForm({ mode: 'all', reValidateMode: 'onChange', resolver: joiResolver(schema) });
  const handlers = {
    onSubmit: (data) => execute(endpoints.app.create(), data),
    onReset: resetState,
  };

  return <View form={form} state={state} handlers={handlers} />;
};

export default Component;
